// @flow
import { CLUSTER_RESOURCES_GRID_FIELDNAMES } from '@streaming-projects/orgs/enums';

const clusterDedicatedPartitionsLimitIncreaseToggleBackendFieldName =
  CLUSTER_RESOURCES_GRID_FIELDNAMES.CLUSTER_DEDICATED_PARTITION_LIMIT_INCREASE_TOGGLE_BACKEND_NAME;

export const getDedicatedPartitionLimitIncreaseToggle = (details) => {
  return details?.[clusterDedicatedPartitionsLimitIncreaseToggleBackendFieldName] ?? false;
};

export const disableDedicatedPartitionLimitIncreaseToggle = (setFieldValue) => {
  setFieldValue(clusterDedicatedPartitionsLimitIncreaseToggleBackendFieldName, false);
};
